// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./fonts.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./animations.css");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./images.css");
var ___CSS_LOADER_AT_RULE_IMPORT_3___ = require("-!../../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./percy.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  apply a natural box layout model to all elements, but allowing components to change
  see: https://www.paulirish.com/2012/box-sizing-border-box-ftw/
*/

:root {
  --glucose-main-font-family: 'Open Sans', 'Noto Sans', sans-serif;
  --glucose-pre-font-family: 'Roboto Mono', 'Lucida Console', Monaco, monospace;
  --glucose-heading-font-family: 'Open Sans', 'Noto Sans', sans-serif;
  --glucose-main-font-weight: 300;
  --glucose-bold-font-weight: 600;
  --glucose-black-font-weight: 600;
  --glucose-link-text-color: #ae0d5c;
  --glucose-link-text-color-active: #880649;
  --glucose-icon-font-family: 'Glucose-Icons';
  --glucose-letter-spacing-title1: '0.008em';
  --glucose-letter-spacing-title2: '0.0074em';
  --glucose-letter-spacing-title3: '0.0063em';
  --glucose-letter-spacing-button1: '0.0156em';
  --glucose-letter-spacing-button2: '0.0125em';
}

html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-family: var(--glucose-main-font-family);
  font-weight: var(--glucose-main-font-weight);
  color: rgba(0, 0, 0, 0.9);
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  padding: 0;
}

body.noScroll {
  overflow: hidden;
}

a {
  color: var(--glucose-link-text-color);
  outline: 0;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
}

a:visited {
  color: var(--glucose-link-text-color);
  text-decoration: none;
}

a:hover,
a:focus,
a:active {
  color: var(--glucose-link-text-color-active);
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: var(--glucose-bold-font-weight);
}

input,
textarea,
button {
  outline: none;
  font-family: var(--glucose-main-font-family);
}

code,
pre {
  font-family: var(--glucose-pre-font-family);
  font-weight: var(--glucose-main-font-weight);
}

/* Remove IE10's “clear field” X button on inputs? */
::-ms-clear {
  width: 0;
  height: 0;
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@signavio/ui/assets/style.css"],"names":[],"mappings":"AAKA;;;CAGC;;AAED;EACE,gEAAgE;EAChE,6EAA6E;EAC7E,mEAAmE;EACnE,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;AACA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;;;;;;EAME,4CAA4C;AAC9C;;AAEA;;;EAGE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,oDAAoD;AACpD;EACE,QAAQ;EACR,SAAS;EACT,aAAa;AACf","sourcesContent":["@import url('fonts.css');\n@import url('animations.css');\n@import url('images.css');\n@import url('percy.css');\n\n/*\n  apply a natural box layout model to all elements, but allowing components to change\n  see: https://www.paulirish.com/2012/box-sizing-border-box-ftw/\n*/\n\n:root {\n  --glucose-main-font-family: 'Open Sans', 'Noto Sans', sans-serif;\n  --glucose-pre-font-family: 'Roboto Mono', 'Lucida Console', Monaco, monospace;\n  --glucose-heading-font-family: 'Open Sans', 'Noto Sans', sans-serif;\n  --glucose-main-font-weight: 300;\n  --glucose-bold-font-weight: 600;\n  --glucose-black-font-weight: 600;\n  --glucose-link-text-color: #ae0d5c;\n  --glucose-link-text-color-active: #880649;\n  --glucose-icon-font-family: 'Glucose-Icons';\n  --glucose-letter-spacing-title1: '0.008em';\n  --glucose-letter-spacing-title2: '0.0074em';\n  --glucose-letter-spacing-title3: '0.0063em';\n  --glucose-letter-spacing-button1: '0.0156em';\n  --glucose-letter-spacing-button2: '0.0125em';\n}\n\nhtml {\n  box-sizing: border-box;\n}\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nbody {\n  font-family: var(--glucose-main-font-family);\n  font-weight: var(--glucose-main-font-weight);\n  color: rgba(0, 0, 0, 0.9);\n  font-size: 16px;\n  line-height: 1.5;\n  margin: 0;\n  padding: 0;\n}\n\nbody.noScroll {\n  overflow: hidden;\n}\n\na {\n  color: var(--glucose-link-text-color);\n  outline: 0;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  cursor: pointer;\n}\n\na:visited {\n  color: var(--glucose-link-text-color);\n  text-decoration: none;\n}\n\na:hover,\na:focus,\na:active {\n  color: var(--glucose-link-text-color-active);\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: var(--glucose-bold-font-weight);\n}\n\ninput,\ntextarea,\nbutton {\n  outline: none;\n  font-family: var(--glucose-main-font-family);\n}\n\ncode,\npre {\n  font-family: var(--glucose-pre-font-family);\n  font-weight: var(--glucose-main-font-weight);\n}\n\n/* Remove IE10's “clear field” X button on inputs? */\n::-ms-clear {\n  width: 0;\n  height: 0;\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
